// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/" + ({"131": "mui","248": "plotly","37": "markdown","505": "mermaid","699": "xlsx","736": "framer-motion","863": "pdf-export",}[chunkId] || chunkId) + "." + {"131": "48efe5ed","248": "18f773bb","341": "69940786","37": "34e7b8d7","490": "c2109686","505": "3508cdd6","548": "8205e8d8","699": "4d64f9af","736": "4f496ffb","810": "4a9485c1","823": "50cbce3b","863": "c0f842ea",}[chunkId] + ".chunk.js"
}